import { Component } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { Product } from '@interfaces/interfaces';
import { BffApiService } from '@shared/bff-api.service';
import { NavigationService } from '../../../shared/service/navigation.service';
import { ProductListService } from '../../../shared/service/product-list.service';

@Component({
  selector: 'app-stocks',
  templateUrl: './stocks.component.html',
  styleUrls: ['./stocks.component.scss'],
  imports: [MatTableModule],
})
export class StocksComponent {
  isTableExpanded = false;
  productList = []; //products

  dataProductsList = new MatTableDataSource();
  displayedColumns: string[] = [
    //'checkbox',
    'name',
    'categories',
    'brand',
    'actions',
  ];
  isAddVariant: boolean = false;

  protected products: Product[] = [];

  constructor(private bff: BffApiService, private pService: ProductListService, private nav: NavigationService) {
    this.bff.getStock().subscribe((data) => {
      this.products = data;
      this.dataProductsList.data = data;
    });
    this.dataProductsList.data = [];
  }

  addProductToVestra(stockProd: Product) {
    this.pService.changeProduct(stockProd);
    this.nav.goToEditArticle();
  }

  refreshStock() {
    this.bff.getStock().subscribe((data) => console.log(data));
  }
}
